import Modal from "@ui-components/Modal";
import {MergeRequestModalProps} from "./types";
import {useState} from "react";
import { useIntl } from "react-intl";

export const MergeRequestModal = ({name, email, onClose, onConfirm}: MergeRequestModalProps) => {

  // hooks
  const intl = useIntl();

  // state
  const [submitting, setSubmitting] = useState(false)

  return (
    // @ts-ignore
    <Modal
      type="warning"
      title={intl.formatMessage({
        id: "merge_users_request",
        defaultMessage: "Utente già registrato",
      })}
      description={intl.formatMessage(
        {
          id: "merge_users_request_description",
          defaultMessage: "Esiste già un altro utente con l'indirizzo email {email}. Vuoi inviargli una richiesta di conversione dell'utenza?",
        },
        {
          name: <span className="font-semibold">{name}</span>,
          email: <span className="font-semibold">{email}</span>,
        }
      )}
      onExit={onClose}
      onDismiss={onClose}
      onConfirm={async () => {
        setSubmitting(true)
        try {
          await onConfirm();
        }
        finally {
          setSubmitting(false)
        }
      }}
      submitting={submitting}
    />
  )
};